
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { namespace, Getter } from "vuex-class";
import Multiselect from "vue-multiselect";
import { EventDetails } from "@/store/site-monitor/types";
import { DispatchGuard } from "@/store/dispatch/types";
import { Group } from "@/store/eventqueue/types";

const SiteMonitor = namespace("siteMonitor");
const Dispatch = namespace("dispatch");

@Component({
	components: {
		multiselect: Multiselect,
	},
})
export default class EventRaise extends Vue {
	$refs!: {
		eventRaiseModal: any;
	};

	@Getter("getPreviousRoute") private returnPath: string;

	@SiteMonitor.Getter("getEventDetails") private eventDetails: EventDetails;
	@SiteMonitor.Getter("getEventRaiseShown") private eventRaiseShown!: boolean;

	@SiteMonitor.Action private changeEventRoutingGroup: ({ eventId, RoutingGroupId }) => Promise<any>;
	@SiteMonitor.Action private loadRoutingGroupsByEvent: (eventID: number) => Promise<Group[]>;

	@SiteMonitor.Mutation private setEventRaiseShown: (visible: boolean) => void;
	@SiteMonitor.Mutation private setEventDetails: (eventDetails: EventDetails) => void;

	@Dispatch.Action private setDispatchedGuard: (guards: DispatchGuard[]) => void;

	@Prop(Number) private eventid?: number;

	public raiseError: string = "";
	public selectedRoutingGroup: any = {};
	public groups: any[] = [];

	@Watch("eventRaiseShown")
	private async onEventRaiseShownChanged(value: boolean) {
		if (value) {
			await this.show();
		} else {
			this.$refs.eventRaiseModal.hide();
		}
	}

	public async show() {
		this.groups = await this.loadRoutingGroupsByEvent(this.eventDetails.eventID);
		this.$refs.eventRaiseModal.show();
	}

	public async raiseEvent() {
		const data = {
			eventId: this.eventid,
			RoutingGroupId: this.selectedRoutingGroup.routingGroupID,
		};

		var result = await this.changeEventRoutingGroup(data);

		if (result.success) {
			this.setEventRaiseShown(false);
			this.setDispatchedGuard(null);
			this.setEventDetails(null);

			// If this event was opened in a new window (and not from Views), close it
			if (window.opener !== null && this.returnPath != "/views") {
				window.close();
			} else {
				// send the user back to where they came from (if not set, return to event queue)
				let url = this.returnPath == "/" ? "/event-queue" : this.returnPath;
				this.$router.push({ path: url });
			}
		}
	}

	private cancelRaiseEvent() {
		this.setEventRaiseShown(false);
	}
}
